import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "@/lib/api";

export default function RequireAdmin() {
  const token = getToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
